// extracted by mini-css-extract-plugin
export default {"container":"orderKitContent_container__ZCRJP","headTitle":"orderKitContent_headTitle__EEYSF","addNew":"orderKitContent_addNew__Ykjcp","icon":"orderKitContent_icon__UeDTE"};